import { Link } from "gatsby";
import { PropsWithChildren } from "react";
import styled from "styled-components";

import { Box } from "@vinomofo/components";

import { ContentBlock } from "../../component-factory/content-block";

const PlainLink = styled(Link)`
  text-decoration: none;
  width: 100%;
`;
const BannerLink = ({ to, children }: PropsWithChildren<{ to?: string }>) => {
  return to ? <PlainLink to={to}>{children}</PlainLink> : children;
};

interface BannerGroupLayoutProps {
  contentBlocks: Array<any>;
}

export const BannerGroupLayout = ({
  contentBlocks,
}: PropsWithChildren<BannerGroupLayoutProps>): JSX.Element => {
  const [featuredContentBlock, ...otherBlocks] = contentBlocks;

  return (
    <Box
      display="flex"
      width="100%"
      height={["auto", "585px"]}
      flexDirection={["column", "row"]}
    >
      <Box flex={7} height="100%">
        <ContentBlock {...featuredContentBlock} hero />
      </Box>
      <Box flex={4}>
        {otherBlocks.slice(0, 2).map((contentBlock, index) => {
          const { linkTo, ...rest } = contentBlock;
          const ctaLink = linkTo?.url;

          return (
            <BannerLink key={index} to={ctaLink}>
              <ContentBlock {...rest} />
            </BannerLink>
          );
        })}
      </Box>
    </Box>
  );
};
